// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2fjuD","info":"Note_info__2Zmxq","note":"Note_note__3Yr1A","actions":"Note_actions__25Vw6"};